"use client"

/**
 * 端末ID（frontend/shared/auth）。
 *
 * ブラウザ(端末)ごとに一意なIDを localStorage に永続化する。複数端末同時ログイン対策で
 * 「稼働端末の排他(active_device_id)」「アプリの所有端末(セッション締め出し)」の識別に使う。
 * リロードしても不変なので、リロードした端末が自分自身を締め出す/稼働権を失うことはない。
 */

const DEVICE_ID_KEY = "cti-device-id"

// crypto.randomUUID 非対応環境向けの簡易フォールバック（RFC4122 v4 形式）。
function fallbackUuid(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (ch) => {
    // Math.random で十分（暗号強度は不要。端末識別のみが目的）
    const r = (Math.random() * 16) | 0
    const v = ch === "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/**
 * この端末のIDを返す（無ければ生成して永続化）。
 * SSR や localStorage 非対応環境では空文字を返す（サーバ側は deviceId 未指定として扱う）。
 */
export function getDeviceId(): string {
  if (typeof window === "undefined") return ""
  try {
    let id = window.localStorage.getItem(DEVICE_ID_KEY)
    if (!id) {
      id = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : fallbackUuid()
      window.localStorage.setItem(DEVICE_ID_KEY, id)
    }
    return id
  } catch {
    return ""
  }
}
